export const getInitialState = (): any => ({
  modelListData: {},
  modelListStatus: 0
});
